import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Escolha o seu plano inicial <br/> Tratamos de tudo, <underline>VOCÊ</underline> descansa 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Pagar depois pelas vendas',
    [BillingMode.Stripe]: '(0)[Pagar agora];(1-inf)[Pagar agora (poupe até {{discount}})]',
  },
};
